module.exports = __webpack_public_path__ + "media/images/wave1-821e7e9e4c3b2da084fa4ffd39b99d77.png";